const LongformRow = {
  getSettings: componentSettings => ({
    ...componentSettings,
    modifier: 'longform-row'
  })
};

export default LongformRow;
